<template>
  <vx-card :title="$t('sections.accounting.dataSection.paymentDetail')" refresh-content-action @refresh="handleRefreshClick">
    <template v-if="visible">
      <ValidationObserver v-slot="{ invalid }">
        <!--JOB DETAIL STATUS & CALL DATE-->
        <div class="vx-row mb-2">
          <div class="vx-col w-full sm:w-1/3 mb-2">
            <ValidationProvider :name="$t('sections.accounting.dataForm.actionType')" rules="required" v-slot="{ errors }">
              <label class="text-sm">{{ $t("sections.accounting.dataForm.actionType") + ' *' }}</label>
              <v-select :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" :options="actionTypesOptions" :reduce="res => res.value" @input="handleDetailStatusSelect" v-model="form.actionType"/>
              <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col w-full sm:w-1/3 mb-2" v-if="visibleDate">
            <ValidationProvider :name="$t('sections.accounting.dataForm.paidDate')" rules="required" v-slot="{ errors }" >
              <label class="text-sm">{{ $t('sections.accounting.dataForm.paidDate') + ' *' }}</label>
              <flat-pickr :config="configDateTimePicker" class="w-full" v-model="form.date"/>
              <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col w-full sm:w-1/6 mb-2" v-if="visibleLoanDetailType">
            <ValidationProvider :name="$t('sections.accounting.dataForm.tableLoanDetail.type')" rules="required" v-slot="{ errors }" >
              <label class="text-sm">{{ $t('sections.accounting.dataForm.tableLoanDetail.type') + ' *' }}</label>
                <vs-select v-model="form.loanDetailType" class="w-full select-large">
                  <vs-select-item :key="index" :value="item.value" :text="item.label" v-for="(item,index) in loanDetailTypesOptions"/>
                </vs-select>
              <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col w-full sm:w-1/6 mb-2" v-if="visibleAmount">
            <ValidationProvider :name="$t('sections.accounting.dataForm.paidAmount')" rules="required" v-slot="{ errors }" >
              <label class="text-sm">{{ $t('sections.accounting.dataForm.paidAmount') + ' *' }}</label>
              <vs-input type="number" class="w-full" v-model="form.amount" v-on:keyup.enter="onEnter(invalid)"/>
              <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col w-full sm:w-1/6 mb-2" v-if="visiblePaymentPrinciple">
            <ValidationProvider :name="$t('sections.accounting.dataForm.paymentPrinciple')" rules="" v-slot="{ errors }" >
              <label class="text-sm">{{ $t('sections.accounting.dataForm.paymentPrinciple')}}</label>
              <vs-checkbox v-model="form.paymentPrinciple"></vs-checkbox>
              <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col w-full sm:w-1/6 mb-2" v-if="visibleAdjustment">
            <ValidationProvider :name="$t('sections.accounting.dataForm.adjustment')" rules="" v-slot="{ errors }" >
              <label class="text-sm">{{ $t('sections.accounting.dataForm.adjustment')}}</label>
              <vs-checkbox v-model="form.adjustment"></vs-checkbox>
              <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col w-full sm:w-1/6 mb-2" v-if="visiblePaymentRoundPeriod">
            <ValidationProvider :name="$t('sections.accounting.dataForm.paymentRoundPeriod')" rules="required" v-slot="{ errors }" >
              <label class="text-sm">{{ $t('sections.accounting.dataForm.paymentRoundPeriod') + ' *' }}</label>
              <vs-input type="number" class="w-full" v-model="form.paymentRoundPeriod"/>
              <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col w-full sm:w-1/6 mb-2" v-if="visiblePaymentRoundType">
            <ValidationProvider :name="$t('sections.accounting.dataForm.tablePaymentRound.type')" rules="required" v-slot="{ errors }" >
              <label class="text-sm">{{ $t('sections.accounting.dataForm.tablePaymentRound.type') + ' *' }}</label>
              <vs-select v-model="form.paymentRoundType" class="w-full select-large">
                <vs-select-item :key="index" :value="item.value" :text="item.label" v-for="(item,index) in paymentRoundTypesOptions"/>
              </vs-select>
              <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col w-full sm:w-1/6 mb-2" v-if="visiblePaymentRoundAmount">
            <ValidationProvider :name=" $t('sections.accounting.dataForm.tablePaymentRound.amount')" rules="required" v-slot="{ errors }" >
              <label class="text-sm">{{  $t('sections.accounting.dataForm.tablePaymentRound.amount') + ' *' }}</label>
              <vs-input type="number" class="w-full" v-model="form.paymentRoundAmount"/>
              <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col w-full sm:w-1/6 mb-2" v-if="visiblePaymentRoundExtra">
            <ValidationProvider :name="$t('sections.accounting.dataForm.tablePaymentRound.extra')" rules="" v-slot="{ errors }" >
              <label class="text-sm">{{ $t('sections.accounting.dataForm.tablePaymentRound.extra')}}</label>
              <vs-checkbox v-model="form.paymentRoundExtra"></vs-checkbox>
              <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col w-full sm:w-1/3 mb-2" v-if="visibleForecastDate">
            <ValidationProvider :name="$t('sections.accounting.dataForm.forecastDate')" rules="" v-slot="{ errors }" >
              <label class="text-sm">{{ $t('sections.accounting.dataForm.forecastDate') + ' *' }}</label>
              <flat-pickr :config="configDateTimePicker" class="w-full" v-model="form.forecastDate"/>
              <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col w-full sm:w-1/3 mb-2" v-if="visibleGraduationDate">
            <ValidationProvider :name="$t('sections.accounting.dataForm.graduationDate')" rules="" v-slot="{ errors }" >
              <label class="text-sm">{{ $t('sections.accounting.dataForm.graduationDate') + ' *' }}</label>
              <flat-pickr :config="configDateTimePicker" class="w-full" v-model="form.graduationDate"/>
              <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col w-full sm:w-1/3 mb-2" v-if="visibleEducationStatus">
            <validation-provider :name="$t('sections.accounting.dataForm.educationStatus')" rules="required" v-slot="{ errors }">
              <label class="vs-input--label">{{$t('sections.accounting.dataForm.educationStatus')}}/{{$t('sections.accounting.dataForm.educationStatus')}}</label>
              <vs-select v-model="form.educationStatus" class="w-full select-large">
                <vs-select-item :key="index" :value="item.value" :text="item.label" v-for="(item,index) in educationStatusesOptions"/>
              </vs-select>
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </validation-provider>
          </div>
          <div class="vx-col w-full">
          <div class="vx-row w-full">
            <div class="vx-col w-full sm:w-1/2 mb-2" v-if="visibleInterestRate">
              <ValidationProvider :name=" $t('sections.accounting.dataForm.loan.interestRate')" rules="required" v-slot="{ errors }" >
                <label class="text-sm">{{  $t('sections.accounting.dataForm.loan.interestRate') + ' *' }}</label>
                <vs-input type="number" class="w-full" v-model="form.interestRate"/>
                <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full sm:w-1/2 mb-2" v-if="visiblePenaltyRate">
              <validation-provider :name="$t('sections.accounting.dataForm.loan.interestType')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{$t('sections.accounting.dataForm.loan.interestType')}}</label>
                <vs-select v-model="form.interestType" class="w-full select-large">
                  <vs-select-item :key="index" :value="item.value" :text="item.label" v-for="(item,index) in interestTypesOptions" class="w-full"/>
                </vs-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/2 mb-2" v-if="visibleInterestType">
              <ValidationProvider :name=" $t('sections.accounting.dataForm.loan.penaltyRate')" rules="required" v-slot="{ errors }" >
                <label class="text-sm">{{  $t('sections.accounting.dataForm.loan.penaltyRate') + ' *' }}</label>
                <vs-input type="number" class="w-full" v-model="form.penaltyRate"/>
                <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full sm:w-1/2 mb-2" v-if="visiblePenaltyType">
              <validation-provider :name="$t('sections.accounting.dataForm.loan.penaltyType')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{$t('sections.accounting.dataForm.loan.penaltyType')}}</label>
                <vs-select v-model="form.penaltyType" class="w-full select-large">
                  <vs-select-item :key="index" :value="item.value" :text="item.label" v-for="(item,index) in interestTypesOptions" class="w-full"/>
                </vs-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/2 mb-2" v-if="visibleInterestType">
              <validation-provider name="ค่าธรรมเนียมการทวงถาม" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">ค่าธรรมเนียมการทวงถาม</label>
                <vs-input type="text" class="w-full" v-model="form.debtCollectionFeeAmount" disabled="disabled" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/2 mb-2" v-if="visiblePenaltyType">
              <validation-provider name="การคิดค่าธรรมเนียมการทวงถาม" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">การคิดค่าธรรมเนียมการทวงถาม</label>
                <vs-select v-model="form.debtCollectionFeeType" class="w-full">
                  <vs-select-item :key="index" :value="item.value" :text="item.label" v-for="(item,index) in debtCollectionFeeTypesOptions" class="w-full"/>
                </vs-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          </div>
        </div>
        <!--REMARK-->
        <div class="vx-row  mb-2">
          <div class="vx-col w-full" v-if="visibleRemark">
            <ValidationProvider :name="$t('sections.accounting.dataForm.paidRemark')" rules="" v-slot="{ errors }">
              <label class="text-sm">{{$t('sections.accounting.dataForm.paidRemark') + ' *'}}</label>
              <vs-textarea rows="3" v-model="form.remark"/>
              <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
            </ValidationProvider>
          </div>
        </div>

        <vs-alert :active.sync="showSuggestion" :title="$t('suggestion.paymentSuggestion.title')" closable close-icon="icon-x" icon="icon-info" icon-pack="feather">
          <p v-html="paymentSuggestion"></p>
        </vs-alert>

        <!----------------------------------------- Actions Button ---------------------------------------------------->
        <div class="vx-row">
          <div class="vx-col w-1/2 mt-3 flex justify-between">
            <div>
              <vs-button :disabled="status.processing || invalid || disableSaveButton" @click.prevent="handleSaveClick" class="mr-2" color="primary">
                {{ $t('general.save') }}
              </vs-button>
              <vs-button @click.prevent="handleBackClick" color="warning" type="border">{{ $t('general.back') }}
              </vs-button>
            </div>
          </div>
        </div>
      </ValidationObserver>
    </template>
  </vx-card>
</template>

<script>
  /* eslint-disable no-unused-vars */
  import moment from 'moment/moment';
  import vSelect from 'vue-select';
  import flatPickr from 'vue-flatpickr-component'
  import { Thai } from 'flatpickr/dist/l10n/th';
  import 'flatpickr/dist/themes/dark.css';
  const _ = require('lodash');
  import {createNamespacedHelpers, mapGetters } from 'vuex';
  import {
    IDebtCollectionFeeType,
    IEducationStatus,
    IInterestType,
    ILoanDetailType,
    IPaymentRoundType
  } from "@/constants/interface";
  import {interestRateDefault} from "@/constants/config";

  const { mapActions: mapAccountingActions, mapState: mapAccountingState} = createNamespacedHelpers('Accounting');

  export default {
    name: "ContractInputForm",
    components: {
      vSelect,
      flatPickr,
    },
    data() {
      return {
        form: {
          actionType: '',
          date: '',
          amount: 0,
          paymentPrinciple: false,
          adjustment: false,
          paymentRoundPeriod: 1,
          paymentRoundType: '',
          paymentRoundExtra: false,
          paymentRoundAmount: 0,
          educationStatus: '',
          forecastDate: '',
          graduationDate: '',
          interestType: IInterestType.principle,
          interestRate: 0,
          penaltyType: IInterestType.principle,
          penaltyRate: 0,
          debtCollectionFeeAmount: interestRateDefault.debtCollectionFeeAmount,
          debtCollectionFeeType: IDebtCollectionFeeType.fixed,
          remark: ''
        },
        selected: [],
        showSuggestion: false,
        paymentSuggestion: ''
      }
    },
    watch: {
      status: {
        handler(res){
          if(res.processing !== null){
            if(res.processing){
              this.$vs.loading();
            }else{
              this.$vs.loading.close();
            }
          }
          if(res.success !== null){
            this.$vs.notify({...res.success})
          }else if(res.error !== null){
            this.$vs.notify({...res.error})
          }
        },
        deep: true
      },
      "form.actionType": {
        immediate: true,
        handler(value) {
          const vm = this
          if(value === "AddInterestRate"){
            const interestRateDetail = _.orderBy(vm.interestRateDetails , ['interestDate'], ['desc']).find(res => {
              let interestDate = moment(res.interestDate)
              return moment().isSameOrAfter(interestDate)
            })
            vm.form.interestRate = ( interestRateDetail ? interestRateDetail.interestRate : 0)
            vm.form.penaltyRate = ( interestRateDetail ? interestRateDetail.penaltyRate : 0)
          }else if(value === "EditEducationStatus"){
            vm.form.educationStatus = vm.contract.educationStatus
            vm.form.forecastDate = vm.$options.filters.convYYYYMMDDToDDMMYYYY(vm.contract.forecastDate)
            vm.form.graduationDate = vm.$options.filters.convYYYYMMDDToDDMMYYYY(vm.contract.graduationDate)
          }
        }
      },
    },
    async created() {
      const vm = this
      vm.reset();
    },
    computed: {
      ...mapGetters({
        loanTypesOptions: "Master/loanTypesOptions",
        actionTypesOptions: "Master/actionTypesOptions",
        paymentRoundTypesOptions: "Master/paymentRoundTypesOptions",
        loanDetailTypesOptions: "Master/loanDetailTypesOptions",
        educationStatusesOptions: "Master/educationStatusesOptions",
        interestTypesOptions: "Master/interestTypesOptions",
        debtCollectionFeeTypesOptions: "Master/debtCollectionFeeTypesOptions",
      }),
      ...mapAccountingState(['status', 'contract', 'loanDetails', 'feeDetails', 'paymentRounds', 'payments', 'transactions', 'interestRateDetails',]),
      visible(){
        return !_.isEmpty(this.contract);
      },
      visibleDate() {
        const visible = ["AddLoan","AddLoanPlan","AddFee","AddPayment","AddInterestRate"]
        return visible.includes(this.form.actionType);
      },
      visibleLoanDetailType() {
        const visible = ["AddLoan","AddLoanPlan"]
        return visible.includes(this.form.actionType);

      },
      visibleAmount() {
        const visible = ["AddLoan","AddLoanPlan","AddFee","AddPayment"]
        return visible.includes(this.form.actionType);

      },
      visibleAdjustment() {
        const visible = ["AddPayment"]
        return visible.includes(this.form.actionType);

      },
      visiblePaymentPrinciple() {
        const visible = ["AddPayment"]
        return visible.includes(this.form.actionType);

      },
      visiblePaymentRoundPeriod() {
        const visible = ["AddPaymentRound"]
        return visible.includes(this.form.actionType);

      },
      visiblePaymentRoundType() {
        const visible = ["AddPaymentRound"]
        return visible.includes(this.form.actionType);

      },
      visiblePaymentRoundExtra() {
        const visible = ["AddPaymentRound"]
        return visible.includes(this.form.actionType);

      },
      visiblePaymentRoundAmount() {
        const visible = ["AddPaymentRound"]
        return visible.includes(this.form.actionType);

      },
      visibleEducationStatus() {
        const visible = ["EditEducationStatus"]
        return visible.includes(this.form.actionType);

      },
      visibleForecastDate() {
        const visible = ["EditEducationStatus"]
        return visible.includes(this.form.actionType);

      },
      visibleGraduationDate() {
        const visible = ["EditEducationStatus"]
        return visible.includes(this.form.actionType);

      },
      visibleInterestRate() {
        const visible = ["AddInterestRate"]
        return visible.includes(this.form.actionType);

      },
      visiblePenaltyRate() {
        const visible = ["AddInterestRate"]
        return visible.includes(this.form.actionType);

      },
      visibleInterestType() {
        const visible = ["AddInterestRate"]
        return visible.includes(this.form.actionType);

      },
      visiblePenaltyType() {
        const visible = ["AddInterestRate"]
        return visible.includes(this.form.actionType);

      },
      visibleRemark() {
        const visible = ["AddLoan","AddLoanPlan","AddFee","AddPaymentRound","AddPayment","AddInterestRate"]
        return visible.includes(this.form.actionType);

      },
      disableSaveButton() {
        const vm = this
        if(vm.form.actionType === "AddLoan"){
          if(!vm.form.amount) return true
            return vm.contract.educationStatusExternal !== 'Normal';
        }if(vm.form.actionType === "AddLoanPlan"){
          return !vm.form.amount;
        }else if(vm.form.actionType === "AddFee"){
          return !vm.form.amount;
        }else if(vm.form.actionType === "AddPaymentRound"){
          return false
        }else if(vm.form.actionType === "AddPayment"){
          return !vm.form.amount;
        }else if(vm.form.actionType === "AddInterestRate"){
          return !vm.form.interestRate;
        }else if(vm.form.actionType === "EditEducationStatus"){
          return false
        }else{
          return false
        }
      },
      configDateTimePicker(){
        const vm = this
        let minDate = null
        let maxDate = null
        if(vm.form.actionType === 'AddLoan' && vm.loanDetails.length >= 1){
          minDate = moment().format("DD-MM-YYYY")
          maxDate = moment().format("DD-MM-YYYY")
          vm.form.date = moment().format("DD-MM-YYYY");
        }else if(vm.form.actionType === 'AddPayment' && vm.payments.length >= 1){
          minDate = moment(vm.payments[vm.payments.length - 1].paymentDate).format("DD-MM-YYYY")
        }
        return {
          monthSelectorType: "static",
          allowInput: true,
          locale: Thai,
          dateFormat: "d-m-Y",
          minDate,
          maxDate
        }
      }
    },
    methods: {
      ...mapAccountingActions(['createLoanDetail', 'createLoanDetailPlan', 'createFeeDetail', 'createPaymentRounds', 'createPayment', 'createInterestRateDetail', 'getContractTransactionManageRefresh', 'getTransactionsByContractIdRefresh', 'getLoanDetailPlansByContractId', 'setEducationStatus']),
      async onEnter(invalid){
        if( !this.status.processing && !invalid && !this.disableSaveButton ){
          await this.handleSaveClick()
        }
      },
      async handleRefreshClick(card) {
        const vm = this
        await vm.reset()
        card.removeRefreshAnimation(500)
      },
      async handleSaveClick() {
        const vm = this
        if(vm.form.actionType === "AddInterestRate"){
          const vm = this
          const { createInterestRateDetail } = vm
          await createInterestRateDetail ({
            contractId: vm.$route.params.id,
            form: {
              interestDate: vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.form.date.trim()),
              interestType: vm.form.interestType,
              interestRate: parseFloat(vm.form.interestRate),
              penaltyType: vm.form.penaltyType,
              penaltyRate: parseFloat(vm.form.penaltyRate),
              debtCollectionFeeType: vm.form.debtCollectionFeeType,
              remark: vm.form.remark,
            },
            vm
          });
        }else if(vm.form.actionType === "EditEducationStatus"){
          const vm = this
          const { setEducationStatus } = vm
          await setEducationStatus ({
            contractId: vm.$route.params.id,
            form: {
              educationStatus: vm.form.educationStatus,
              forecastDate: vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.form.forecastDate.trim()),
              graduationDate: vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.form.graduationDate.trim()),
            },
            vm
          });
        }
        await vm.reset()
      },
      handleBackClick(){
        this.$router.push('/accounting/transaction');
      },
      handleDetailStatusSelect() {
        const vm = this;
        vm.showSuggestion = false;
        vm.paymentSuggestion = '';
        setTimeout(function () {
          try {
            vm.paymentSuggestion = vm.$t('suggestion.paymentSuggestion')[vm.form.actionType]
          } catch (error) {
            vm.paymentSuggestion = ''
          }
          vm.showSuggestion = vm.paymentSuggestion !== '';
        }, 100)
      },
      async reset() {
        const vm = this;
        vm.form = {
          actionType: 'AddInterestRate',
          date: moment().format('DD-MM-YYYY'),
          amount: 0,
          adjustment: false,
          paymentPrinciple: false,
          paymentRoundPeriod: 1,
          loanDetailType: ILoanDetailType.tuitionFee,
          paymentRoundType: IPaymentRoundType.principle,
          paymentRoundExtra: false,
          paymentRoundAmount: 0,
          educationStatus: IEducationStatus.normal,
          forecastDate: '',
          graduationDate: '',
          interestType: IInterestType.principle,
          interestRate: 0,
          penaltyType: IInterestType.principle,
          penaltyRate: 0,
          debtCollectionFeeAmount: interestRateDefault.debtCollectionFeeAmount,
          debtCollectionFeeType: IDebtCollectionFeeType.fixed,
          remark: ''
        };
        vm.showSuggestion = false,
        vm.paymentSuggestion = ''
      }
    },
  }
</script>

<style scoped>

</style>
